class PdpBundleQty extends HTMLElement {
  constructor() {
    super();
    this.cards = this.querySelectorAll('.pdp-bundle__card');
    this.sectionId = this.dataset.sectionId;
    this.defaultQty = parseInt(this.dataset.defaultQuantity || '1', 10);
    this.onCardClick = this.onCardClick.bind(this);
  }

  connectedCallback() {
    this.cards.forEach((card) => card.addEventListener('click', this.onCardClick));
    const input = document.querySelector(`#Quantity-${this.sectionId}`);
    const inputQty = input ? parseInt(input.value, 10) : NaN;
    if (input && !Number.isNaN(inputQty)) {
      const match = Array.from(this.cards).find((c) => parseInt(c.dataset.quantity, 10) === inputQty);
      if (match) {
        this.cards.forEach((c) => {
          const active = c === match;
          c.classList.toggle('is-active', active);
          c.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        return;
      }
    }
  }

  disconnectedCallback() {
    this.cards.forEach((card) => card.removeEventListener('click', this.onCardClick));
  }

  onCardClick(event) {
    const card = event.currentTarget;
    const qty = parseInt(card.dataset.quantity, 10);
    if (Number.isNaN(qty)) return;

    this.cards.forEach((c) => {
      const active = c === card;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.syncQuantityInput(qty);
  }

  syncQuantityInput(qty) {
    const selector = `#Quantity-${this.sectionId}`;
    const input = document.querySelector(selector);
    if (!input) return;
    if (parseInt(input.value, 10) === qty) return;
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('pdp-bundle-qty')) {
  customElements.define('pdp-bundle-qty', PdpBundleQty);
}
